export default function getParameterFromErrorResponse(message) {
  const parametres = message?.split('|')[0]?.split('@');
  parametres?.shift();
  return parametres ?? [];
}
